
function DNDRedirect({src, elementStyle, changeSelection}) {

    return (
        <div id="redirect" data-tour="rpdesigner-step-3"
            style={elementStyle} 
            onClick={changeSelection}
            >
            redirect to {src}
        </div>
    )
}

export default DNDRedirect;